import { faArrowLeftArrowRight } from "@jewlr/sharp-light-svg-icons/faArrowLeftArrowRight"
import { faDollarSign } from "@jewlr/sharp-light-svg-icons/faDollarSign"
import { faLeafMaple } from "@jewlr/sharp-light-svg-icons/faLeafMaple"
import { faRingsWedding } from "@jewlr/sharp-light-svg-icons/faRingsWedding"
import { faShieldCheck } from "@jewlr/sharp-light-svg-icons/faShieldCheck"
import { faTruckFast } from "@jewlr/sharp-light-svg-icons/faTruckFast"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import {
  IS_AU,
  IS_NA,
  IS_UK,
  IS_GE_CHECKOUT,
  jewlr_t,
} from "helpers/application"

const getValueProps = (hasResizableRing) => {
  let valueProps = [
    {
      icon: faArrowLeftArrowRight,
      key: "returns",
      title: `${IS_GE_CHECKOUT() ? "30" : "99"}-Day Return Policy`,
    },
    {
      icon: faTruckFast,
      key: "shipping",
      title: `Free ${jewlr_t("terms.Shipping")}`,
    },
    {
      icon: faShieldCheck,
      key: "warranty",
      title: "One-Year Warranty",
    },
  ]

  if (IS_AU() || IS_UK()) {
    valueProps.push({
      icon: faDollarSign,
      key: "duties",
      title: "Duties Included",
    })
  } else if (IS_NA() && hasResizableRing) {
    valueProps.push({
      icon: faRingsWedding,
      key: "resizing",
      title: "Free Ring Resizing",
    })
  } else {
    valueProps.push({
      icon: faLeafMaple,
      key: "made-in-canada",
      title: "Made in Canada",
    })
  }

  return valueProps
}

const ValuePropItem = ({ icon, title }) => (
  <div className="flex items-center gap-8">
    <FontAwesomeIcon
      className="text-18 tablet:text-16 h-auto w-[1em] shrink-0"
      icon={icon}
    />
    <p className="flex-1">{title}</p>
  </div>
)

ValuePropItem.propTypes = {
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

const StickyCheckoutValueProps = () => {
  const hasResizableRing = useSelector(
    (state) => state.cart.summary?.has_resizable_ring
  )
  const valueProps = getValueProps(hasResizableRing)

  return (
    <div className="text-15 tablet:px-0 tablet:gap-x-8 my-16 grid grid-cols-2 gap-16 px-8">
      {valueProps.map((prop) => (
        <ValuePropItem icon={prop.icon} key={prop.key} title={prop.title} />
      ))}
    </div>
  )
}

export default StickyCheckoutValueProps
